"use strict";

exports.__esModule = true;
exports.Value = void 0;
const Value = exports.Value = {
  isEmpty: value => value === '' || value === null || value === undefined,
  isIsoString: value => typeof value === 'string' && isoStringRegex.test(value)
};
const isoStringRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?Z$/;
//# sourceMappingURL=value.js.map